// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2nZvS","question":"styles_question__1cs1y","description":"styles_description__dbtUg"};